// Event handler to initate a CSV download using a passed filename and data
export default function initiateCSVDownload(filename, data) {
  return initiateFileDownload(filename, data, 'data:text/csv');
}

export const initiateFileDownload = (filename, data, fileType) => {
  const blob = new Blob([data], { type: `${fileType};charset=utf-8,` });
  if (window.navigator.msSaveBlob) {
    // For IE
    window.navigator.msSaveBlob(blob, filename);
  } else {
    // All other browsers
    const link = document.createElement('a');
    link.setAttribute('href', URL.createObjectURL(blob));
    link.setAttribute('download', filename);
    document.body.appendChild(link); // Required for FF
    link.click();
  }
};

export function extractFilenameFromResponse(response) {
  const defaultFilename = `Alloy-Export-${Date.now()}`;
  const contentDisposition = response.headers.get('Content-Disposition');
  if (contentDisposition) {
    return /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition)[1];
  }
  return defaultFilename;
}
